import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type AlertVariant = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  /** Color variant */
  variant?: AlertVariant;
  /** Alert title */
  title?: string;
  /** Alert content */
  children: ReactNode;
  /** Additional CSS classes */
  className?: string;
}

const VARIANT_CLASSES: Record<AlertVariant, string> = {
  info: 'border-primary-200 bg-primary-50 text-primary-800',
  success: 'border-green-200 bg-green-50 text-green-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  error: 'border-red-200 bg-red-50 text-red-800',
};

export function Alert({ variant = 'info', title, children, className }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn('rounded-lg border p-4', VARIANT_CLASSES[variant], className)}
    >
      {title && <p className="mb-1 font-medium">{title}</p>}
      <div className="text-sm">{children}</div>
    </div>
  );
}
